import { render, staticRenderFns } from "./ProductMetadataItem.vue?vue&type=template&id=cb9fde38&"
import script from "./ProductMetadataItem.vue?vue&type=script&lang=js&"
export * from "./ProductMetadataItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb9fde38')) {
      api.createRecord('cb9fde38', component.options)
    } else {
      api.reload('cb9fde38', component.options)
    }
    module.hot.accept("./ProductMetadataItem.vue?vue&type=template&id=cb9fde38&", function () {
      api.rerender('cb9fde38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ProductMetadata/ProductMetadataItem.vue"
export default component.exports